// import $public from '../../util/public.js'

export default {
  namespaced: true,
  state: {
    type: "list",
    curCard: {},
    remark: "",
  },
  getters: {},
  mutations: {
    set_type(state, params) {
      state.type = params;
    },
    set_curCard(state, params) {
      state.curCard = params;
    },
    set_remark(state, obj) {
      state.remark = obj;
    },
	
  },
  actions: {
    
  },
};
